import { ExtraFee } from '../../../../data/entities';
import FormType, { FieldConfigs } from '../../../../shared/components/FormType';

interface FormContainerProps {
    validated: boolean;
    extraFee: ExtraFee;
    mergeExtraFee: Function;
}

const FormContainer = ({ validated, extraFee, mergeExtraFee }: FormContainerProps) => {
    const fields: FieldConfigs[] = [
        { label: 'Mã chi phí', type: 'text', key: 'extra_fee_code', required: true },
        { label: 'Tên chi phí', type: 'text', key: 'name', required: true },
        { label: 'Giá thành', type: 'text', key: 'price', required: true },
        {
            label: 'Danh mục',
            type: 'dropdown',
            key: 'category',
            options: [
                { text: 'Phuy', value: 'Phuy' },
                { text: 'Thùng', value: 'Thùng' },
                { text: 'Cơ Khí Ô Tô', value: 'Cơ Khí Ô Tô' },
            ],
        },
        // {
        //     label: "Ghi chú",
        //     type: "text",
        //     key: "note",
        // },
    ];

    return (
        <FormType
            title={'Thông tin chi phí kèm theo'}
            fields={fields}
            validated={validated}
            requireData={{
                ...extraFee,
                extra_fee_code: extraFee.extra_fee_code,
                name: extraFee.name,
                price: extraFee.price,
                category: extraFee.category,
            }}
            mergeFormData={mergeExtraFee}
        />
    );
};

export default FormContainer;
